import React from "react"
import { Container, Row, Col } from "reusecore/Layout"
import Box from "reusecore/Box"
import Heading from "reusecore/Heading"
import Text from "reusecore/Text"
import Counter from "reusecore/Counter"
import { SectionTitle, SectionBackground } from "reusecore/SectionTitle"
import walletImage from "assets/images/robot_parts.png"
import SectionParticle from "assets/images/particles/crypto-managment-wallet.svg"
import data from "assets/data/wallet"
import WalletSectionWrapper from "./wallet.style"

const Wallet = () => {
  return (
    <WalletSectionWrapper id="scrapys">
      <Container>
        <img
          src={SectionParticle}
          className="section__particle"
          alt="cryptik"
        />
        <Row>
          <Col className="lg-5 md-4 xs-12">
            <Box className="wallet-image">
              <img src={walletImage} alt="cryptik wallet image" />
            </Box>
          </Col>
          <Col className="lg-6 offset-lg-1 md-8 xs-12">
            <Box className="wallet-left-content">
              <SectionTitle>
                <SectionBackground>
                  <Heading> ¿Armemos tu scrapy?</Heading>
                </SectionBackground>
                <Text>
                Nuestros web scraping son desarrollados a medida, a través del framework Scrapy de Python 3.8. Y son capaces de “scrapear” cualquier sitio web, incluso si tuviese protección antibots. Además, cuenta con tecnología asíncrona, que asegura la extracción más rápida del mercado, siendo hasta cien veces más veloz y económica que los RPA existentes.
                </Text>
                <Text>
                También, esta tecnología es capaz de integrarse con cualquier otro servicio. Por ejemplo, puede exportar la data a S3 (AWS), disponerla en un data-lake o data-warehouse, exportar los resultados a Excel, entre otros. Por lo tanto, nos integramos con la tecnología de terceros que usted requiera.   
                </Text>
              </SectionTitle>

              <Box className="wallet-info">
                {data.wallet.map((item, index) => (
                  <Box className="counter-item" key={index}>
                    <Counter end={item.count} suffix={item.suffixText} />
                    <Text>{item.body}</Text>
                  </Box>
                ))}
              </Box>
            </Box>
          </Col>
        </Row>
      </Container>
    </WalletSectionWrapper>
  )
}

export default Wallet
